module.exports = __webpack_public_path__ + "img/movers-shakers-square.8514702f.png";